<script setup>
import { useRouter } from "vue-router";
import { usePatientStore } from "../../store/patient.js";
import { ref, onBeforeMount, inject } from "vue";
import { showToastWarning } from "@/services/popups";
import { formatFullDate } from "../../services/formatters.js";
 
const patientStore = usePatientStore();
const mySpinner = inject("mySpinner");
const router = useRouter();
const medicalRecordId = router.currentRoute.value.params.recordId;
const patientId = router.currentRoute.value.params.patientId;

const data = ref({
    title: "",
    description: "",
    createdAt: ""
});

const saveMedicalRecord = async () => {
    if(data.value.title === ""){
        showToastWarning("O prontuario precisa ter um título!");
        return;
    }
    if(data.value.description === ""){
        showToastWarning("O prontuario precisa ter uma descrição!");
        return;
    }
    mySpinner.loading = true;
    if(medicalRecordId){
        await patientStore.putPatientMedicalRecord(patientId, medicalRecordId, data.value.title, data.value.description);
    }else{
        await patientStore.postPatientMedicalRecord(patientId, data.value.title, data.value.description);
    }
    mySpinner.loading = false;
}

onBeforeMount(async () => {
    mySpinner.loading = true;
    setTimeout(() => {
      mySpinner.loading = false;
    }, 500);
    
    if(medicalRecordId){
        await patientStore.getPatientMedicalRecord(patientId, medicalRecordId);
        data.value.title = patientStore.selectedPatientMedicalRecord.title;
        data.value.description = patientStore.selectedPatientMedicalRecord.description;
        data.value.createdAt = patientStore.selectedPatientMedicalRecord.createdAt;
    }
});

</script>
<template>
    <nav-bar :returnAction="true" :saveAction="true" :pageName="'Criação de Prontuário'" @save="saveMedicalRecord" @return="$router.push(`/patients/${patientId}/records`)" />

    <main-container :onlyNav="true">
       
       <div class="row w-100">      
            <div class="col-sm-12 mb-2">
                <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; width: 100%;">
                    <label for="recipient-name" class="form-label">Título</label>
                    <span v-if="medicalRecordId">{{ formatFullDate(data.createdAt) }}</span>
                </div>
               <input type="text" v-model="data.title" class="form-control" :disabled="medicalRecordId">
           </div>    
        <div class="col-sm-12 mb-1">                
            <label class="form-label">Descrição</label>                  
            <textarea v-model="data.description" class="form-control textarea" placeholder="Escreva sobre esse paciente..."></textarea>
        </div>
       </div>               
         
   </main-container>
</template>
<style lang='postcss' scoped>

</style>